// import { useQueryClient } from '@tanstack/react-query';
// import React, { createContext, useState, useContext, useEffect, useCallback } from 'react';
// import { useTranslation } from 'react-i18next';

// const LanguageContext = createContext();

// export const LanguageProvider = ({ children }) => {
//     const URL_FROM_ENV = process.env.REACT_APP_IVORY_API;
//     const { i18n } = useTranslation();
//     const queryClient = useQueryClient();

//     // const initialLang = localStorage.getItem('i18nextLng') || 'ar';
//     const initialLang = 'ar';

//     const [lang, setLang] = useState(initialLang);
//     const [URL, setURL] = useState(`${URL_FROM_ENV}/${initialLang}`);

//     const updateLanguage = useCallback((newLang) => {
//         i18n.changeLanguage(newLang);

//         // localStorage.setItem('i18nextLng', newLang);
//         localStorage.setItem('i18nextLng', 'newLang');

//         setLang(newLang);
//         setURL(`${URL_FROM_ENV}/${newLang}`);

//         document.body.dir = newLang === 'en' ? 'ltr' : 'rtl';
//         document.body.lang = newLang;

//         queryClient.resetQueries();
//     }, [URL_FROM_ENV, i18n, queryClient]);

//     const changeLanguage = useCallback((specificLang) => {
//         const newLang = specificLang || (lang === 'ar' ? 'en' : 'ar');
//         updateLanguage(newLang);
        
//         document.body.dir = newLang === 'en' ? 'ltr' : 'rtl';
//         document.body.lang = newLang;

//     }, [lang, updateLanguage]);

//     useEffect(() => {
//         if (i18n.language && i18n.language !== lang) {
//             updateLanguage(i18n.language);
//         }
//         document.body.dir = lang === 'en' ? 'ltr' : 'rtl';
//         document.body.lang = lang;
        
//         const updatingForLocalStorage = (event) => {
//             if (event.key === 'i18nextLng' && event.newValue && event.newValue !== lang) {
//                 updateLanguage(event.newValue);
//             }
//         };

//         window.addEventListener('storage', updatingForLocalStorage);
//         return () => window.removeEventListener('storage', updatingForLocalStorage);
//     }, [i18n.language, lang, updateLanguage]);

//     return (
//         <LanguageContext.Provider value={{ lang, URL, changeLanguage }}>
//             {children}
//         </LanguageContext.Provider>
//     );
// };

// export const useLanguage = () => {
//     const context = useContext(LanguageContext);
//     if (!context) {
//         throw new Error('useLanguage must be used within a LanguageProvider');
//     }
//     return context;
// };


import { useQueryClient } from '@tanstack/react-query';
import React, { createContext, useState, useContext, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
    const URL_FROM_ENV = process.env.REACT_APP_IVORY_API;
    const { i18n } = useTranslation();
    const queryClient = useQueryClient();

    const initialLang = 'ar';

    const [lang, setLang] = useState(initialLang);
    const [URL, setURL] = useState(`${URL_FROM_ENV}/${initialLang}`);

    const updateLanguage = useCallback((newLang) => {
        // Force language to 'ar' always
        const forcedLang = 'ar';
        i18n.changeLanguage(forcedLang);

        // Always set localStorage to 'ar'
        localStorage.setItem('i18nextLng', forcedLang);

        setLang(forcedLang);
        setURL(`${URL_FROM_ENV}/${forcedLang}`);

        document.body.dir = forcedLang === 'en' ? 'ltr' : 'rtl';
        document.body.lang = forcedLang;

        queryClient.resetQueries();
    }, [URL_FROM_ENV, i18n, queryClient]);

    const changeLanguage = useCallback(() => {
        // Ignore toggling, keep Arabic always
        updateLanguage('ar');
    }, [updateLanguage]);

    useEffect(() => {
        if (i18n.language !== lang) {
            updateLanguage('ar');
        }
        document.body.dir = lang === 'en' ? 'ltr' : 'rtl';
        document.body.lang = lang;

        const updatingForLocalStorage = (event) => {
            if (event.key === 'i18nextLng' && event.newValue && event.newValue !== lang) {
                updateLanguage('ar');
            }
        };

        window.addEventListener('storage', updatingForLocalStorage);
        return () => window.removeEventListener('storage', updatingForLocalStorage);
    }, [i18n.language, lang, updateLanguage]);

    return (
        <LanguageContext.Provider value={{ lang, URL, changeLanguage }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within a LanguageProvider');
    }
    return context;
};
